module.exports = __webpack_public_path__ + "media/images/topics/topics-heading-bg-bia-bc3171ba770b55aaa30de04be9cdb125.png";